import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import * as competencesService from '../../Services/competencesService';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import FormInput from '../ReactHookFormCustom/FormInput';
import FormSelect from '../ReactHookFormCustom/FormSelect';
import FormTextArea from '../ReactHookFormCustom/FormTextArea';

const CompetenceModal = ({ showModal, onToggle, modalPurpose, origin, competence }) => {
  const { t } = useTranslation('translations');
  const [isLoading, setIsLoading] = useState(false);
  const { handleSubmit, control, reset } = useForm({});

  const handleValidCompetenceSubmit = (values) => {
    setIsLoading(true);
    if (modalPurpose === 'create') {
      const serviceCall =
        origin === 'FromWizardJobPortal'
          ? competencesService.createNewCompetenceFromWizard
          : competencesService.createNewCompetence;
      serviceCall(values)
        .then((response) => {
          onToggle('reload');
          reset();
        })
        .finally(() => {});
    } else if (modalPurpose === 'edit') {
      competencesService
        .updateCompetence(values)
        .then((response) => {
          onToggle('reload');
          reset();
        })
        .finally(() => {});
    }
  };

  useEffect(() => {
    reset({
      competenceId: competence?.id,
      competenceName: competence?.name,
      competenceType: defaultCompetenceType,
      competenceDescription: competence?.description,
    });
  }, [competence]);

  const competenceTypeOptions = () => {
    return [
      { value: 'Normal', label: 'Normal' },
      { value: 'Boolean', label: 'Boolean' },
      { value: 'Inverse', label: 'Inverse' },
    ];
  };

  const defaultCompetenceType = competenceTypeOptions().find((option) => {
    return option.value === competence.competenceType;
  });

  return (
    <div>
      <Modal isOpen={showModal} centered onClosed={() => setIsLoading(false)}>
        <form onSubmit={handleSubmit(handleValidCompetenceSubmit)}>
          <ModalHeader>
            <em className="fa-2x icon-rocket mr-2"> {t('competences.COMPETENCE')}</em>
          </ModalHeader>
          <ModalBody>
            {/* START card */}
            <Row className="pt-2">
              <Col>
                <FormInput
                  name="competenceName"
                  id="competenceNameId"
                  type="text"
                  label={t('competences.NAME')}
                  control={control}
                  disabled={modalPurpose === 'view'}
                  rules={{ required: t('common.REQUIRED') }}
                />
              </Col>
            </Row>
            <Row className="pt-2">
              <Col>
                <FormSelect
                  name="competenceType"
                  id="competenceTypeId"
                  label={t('competences.COMPETENCE')}
                  control={control}
                  isDisabled={modalPurpose === 'view'}
                  options={competenceTypeOptions()}
                  //defaultValue={defaultCompetenceType}
                  rules={{ required: t('common.REQUIRED') }}
                />
              </Col>
            </Row>
            <Row className="pt-2">
              <Col>
                {modalPurpose === 'view' ? (
                  <>
                    <h4>
                      {t('common.DESCRIPTION')} <em className="text-muted">(optional)</em>:
                    </h4>
                    <div
                      className="popover-header"
                      dangerouslySetInnerHTML={{
                        __html: competence.description,
                      }}
                    />
                  </>
                ) : (
                  <FormTextArea
                    name="competenceDescription"
                    id="competenceDescriptionId"
                    label={t('common.DESCRIPTION')}
                    control={control}
                    maxLength={3000}
                  />
                )}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            {modalPurpose !== 'view' && (
              <div>
                <Button color="primary" className="mx-2" disabled={isLoading}>
                  {isLoading && <div className="spinner-border spinner-border-sm" role="status" />}
                  &nbsp;
                  {t('common.SAVE')}
                </Button>
                <Button color="secondary" onClick={() => onToggle('close')}>
                  {t('common.CANCEL')}
                </Button>
              </div>
            )}
            {modalPurpose === 'view' && (
              <Button color="primary" onClick={() => onToggle('close')}>
                {t('common.OK')}
              </Button>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default CompetenceModal;
